import { baseTheme } from '@/config/themes/baseTheme';
import { Theme } from '@/config/types';

import { setConfigStateById } from '../ConfigContext';

export const changeTheme =
  (setState: setConfigStateById) => (data: { theme: Partial<Theme> | undefined; darkMode: boolean }) => {
    const newTheme = { ...data.theme, typography: { ...baseTheme.typography, ...data.theme?.typography } } as Theme;
    setState('CHANGE_THEME', (s) => ({
      ...s,
      appTheme: newTheme,
      themeName: data.theme?.themeName ?? null,
      darkMode: data.darkMode,
    }));
  };
